import { createContext, useContext, type Dispatch, type SetStateAction } from 'react';

export type AtendabotLayoutContextValue = {
  promptSourceResolved: boolean;
  usesManagerPrompt: boolean;
  restaurante: any;
  setRestaurante: Dispatch<SetStateAction<any>>;
  loadingRestaurant: boolean;
  promptDraftPending: boolean;
  promptReadyToPublish: boolean;
  hasInstanceToken: boolean;
  orderControlEnabled: boolean;
  showOverlay: boolean;
  isBlocked: boolean;
  isZapiUnavailable: boolean;
  checkingZapiStatus: boolean;
  qrImage: string | null;
  qrExpired: boolean;
  loadingQr: boolean;
  loadWhatsappQrCode: () => void | Promise<void>;
  isDesktop: boolean;
  sidebarOpen: boolean;
  mobileMenuOpen: boolean;
  setSidebarOpen: Dispatch<SetStateAction<boolean>>;
  setMobileMenuOpen: Dispatch<SetStateAction<boolean>>;
};

export const AtendabotLayoutContext = createContext<AtendabotLayoutContextValue | null>(null);

/** Full shell state; returns null outside LayoutShell. */
export const useAtendabotLayout = () => useContext(AtendabotLayoutContext);

/** Restaurant slice of the shell context (null outside provider). */
export const useAtendabotRestaurantContext = () => {
  const value = useContext(AtendabotLayoutContext);
  if (!value) return null;
  return {
    restaurante: value.restaurante,
    setRestaurante: value.setRestaurante,
    loadingRestaurant: value.loadingRestaurant,
    promptSourceResolved: value.promptSourceResolved,
    promptDraftPending: value.promptDraftPending,
    promptReadyToPublish: value.promptReadyToPublish,
    hasInstanceToken: value.hasInstanceToken,
    usesManagerPrompt: value.usesManagerPrompt,
  };
};

/** WhatsApp gate slice of the shell context (null outside provider). */
export const useAtendabotWhatsAppGateContext = () => {
  const value = useContext(AtendabotLayoutContext);
  if (!value) return null;
  return {
    showOverlay: value.showOverlay,
    isBlocked: value.isBlocked,
    isZapiUnavailable: value.isZapiUnavailable,
    checkingZapiStatus: value.checkingZapiStatus,
    qrImage: value.qrImage,
    qrExpired: value.qrExpired,
    loadingQr: value.loadingQr,
    loadWhatsappQrCode: value.loadWhatsappQrCode,
  };
};
